
export class ResponseBase {

  handshake?: string | null;
  success?: boolean | null;
  message?: string | null;
}

export class ResponseBaseSet<T> extends ResponseBase {

  data?: T[] | null;

}

export class ResponseBasePage<T> extends ResponseBase {

  data?: T[] | null;
  total: number = 0;
}
